import { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';

interface Props {
  children: React.ReactElement | null;
  portalRootId: string;
}

function Portal({ children, portalRootId }: Props): React.ReactElement | null {
  const portalElement = useRef(document.createElement('div')).current;

  useEffect(() => {
    const portalRoot = document.getElementById(portalRootId);

    if (!portalRoot) {
      return () => undefined;
    }

    portalRoot.appendChild(portalElement);

    return () => {
      portalRoot.removeChild(portalElement);
    };
  }, [portalRootId, portalElement]);

  return children ? createPortal(children, portalElement) : null;
}

export default Portal;
